import script from "./MainScore.vue?vue&type=script&setup=true&lang=js"
export * from "./MainScore.vue?vue&type=script&setup=true&lang=js"

import "./MainScore.vue?vue&type=style&index=0&id=6e4af23a&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4af23a"]])

export default __exports__